import React from "react";
import URLs from "constants/urls";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PipeLineReport from "./pipeLine";
export default function PipeLine() {
  return (
    <DashboardLayout>
      <PipeLineReport />
    </DashboardLayout>
  );
}
